/**
 * Creature Superpowers Game Data
 * Creature cards and superpower cards
 */

import { CreatureCard, SuperpowerCard } from './types';

// Import SVG stickers - Eyes
import eyesHappy from '../earlyChildhood/assets/stickers/eyes-happy.svg';
import eyesRound from '../earlyChildhood/assets/stickers/eyes-round.svg';
import eyesWink from '../earlyChildhood/assets/stickers/eyes-wink.svg';
import eyesHeart from '../earlyChildhood/assets/stickers/eyes-heart.svg';
import eyesStar from '../earlyChildhood/assets/stickers/eyes-star.svg';
import eyesGemstone from '../earlyChildhood/assets/stickers/eyes-gemstone.svg';

// Mouths
import mouthSmile from '../earlyChildhood/assets/stickers/mouth-smile.svg';
import mouthTongue from '../earlyChildhood/assets/stickers/mouth-tongue.svg';
import mouthGentle from '../earlyChildhood/assets/stickers/mouth-gentle.svg';
import mouthSurprised from '../earlyChildhood/assets/stickers/mouth-surprised.svg';

// Hair styles
import hairFire from '../earlyChildhood/assets/stickers/hair-fire.svg';
import hairWater from '../earlyChildhood/assets/stickers/hair-water.svg';
import hairCloud from '../earlyChildhood/assets/stickers/hair-cloud.svg';
import hairVineTendrils from '../earlyChildhood/assets/stickers/hair-vinetendrils.svg';
import hairRainbowMohawk from '../earlyChildhood/assets/stickers/hair-rainbowmohawk.svg';
import hairMushroomCap from '../earlyChildhood/assets/stickers/hair-mushroomcap.svg';
import hairLightningSpikes from '../earlyChildhood/assets/stickers/hair-lightningspikes.svg';
import hairLeafPile from '../earlyChildhood/assets/stickers/hair-leafpile.svg';
import hairIcicleSpikes from '../earlyChildhood/assets/stickers/hair-iciclespikes.svg';

// Ears
import earsLeaf from '../earlyChildhood/assets/stickers/ears-leaf.svg';
import earsCoral from '../earlyChildhood/assets/stickers/ears-coral.svg';
import earsSeashell from '../earlyChildhood/assets/stickers/ears-seashell.svg';
import earsFlowerPetal from '../earlyChildhood/assets/stickers/ears-flowerpetal.svg';
import earsFeather from '../earlyChildhood/assets/stickers/ears-feather.svg';

// Accessories & Crowns
import crown from '../earlyChildhood/assets/stickers/crown.svg';
import crownFlower from '../earlyChildhood/assets/stickers/crown-flower.svg';
import bow from '../earlyChildhood/assets/stickers/bow.svg';
import star from '../earlyChildhood/assets/stickers/star.svg';
import sparkles from '../earlyChildhood/assets/stickers/sparkles.svg';
import hornCrystal from '../earlyChildhood/assets/stickers/horn-crystal.svg';
import beardMoss from '../earlyChildhood/assets/stickers/beard-moss.svg';

// Wings & Tails
import wingsButterfly from '../earlyChildhood/assets/stickers/wings-butterfly.svg';
import wingsLightning from '../earlyChildhood/assets/stickers/wings-lightning.svg';
import tailFirefly from '../earlyChildhood/assets/stickers/tail-firefly.svg';
import tailRainbow from '../earlyChildhood/assets/stickers/tail-rainbow.svg';
import tailFish from '../earlyChildhood/assets/stickers/tail-fish.svg';

// Body & Face markings
import handsStarfish from '../earlyChildhood/assets/stickers/hands-starfish.svg';
import bodyGemstoneBelly from '../earlyChildhood/assets/stickers/body-gemstonebelly.svg';
import faceRainbowStripe from '../earlyChildhood/assets/stickers/face-rainbowstripe.svg';
import faceStarFreckles from '../earlyChildhood/assets/stickers/face-starfreckles.svg';
import markingMoonPhase from '../earlyChildhood/assets/stickers/marking-moonphase.svg';

// Magic Effects
import effectSparkles from '../earlyChildhood/assets/stickers/effect-sparkles.svg';
import effectWater from '../earlyChildhood/assets/stickers/effect-water.svg';
import effectFrost from '../earlyChildhood/assets/stickers/effect-frost.svg';
import effectMagic from '../earlyChildhood/assets/stickers/effect-magic.svg';
import effectGhostly from '../earlyChildhood/assets/stickers/effect-ghostly.svg';
import effectGlowStars from '../earlyChildhood/assets/stickers/effect-glowstars.svg';
import effectMagnetic from '../earlyChildhood/assets/stickers/effect-magnetic.svg';
import effectColorChangeGems from '../earlyChildhood/assets/stickers/effect-colorchangegems.svg';

// Tools
import toolWand from '../earlyChildhood/assets/stickers/tool-wand.svg';
import toolStaff from '../earlyChildhood/assets/stickers/tool-staff.svg';
import toolSnowflake from '../earlyChildhood/assets/stickers/tool-snowflake.svg';
import toolLightning from '../earlyChildhood/assets/stickers/tool-lightning.svg';
import toolShellHorn from '../earlyChildhood/assets/stickers/tool-shellhorn.svg';
import toolLantern from '../earlyChildhood/assets/stickers/tool-lantern.svg';
import toolBouquet from '../earlyChildhood/assets/stickers/tool-bouquet.svg';
import toolAcornPouch from '../earlyChildhood/assets/stickers/tool-acornpouch.svg';

// Decorations
import flower from '../earlyChildhood/assets/stickers/flower.svg';
import heart from '../earlyChildhood/assets/stickers/heart.svg';
import butterfly from '../earlyChildhood/assets/stickers/butterfly.svg';

export const CREATURE_CARDS: CreatureCard[] = [
  {
    type: 'dragon',
    name: {
      en: 'Dragon',
      es: 'Dragón'
    },
    description: {
      en: 'Fire-breathing friend with mighty wings',
      es: 'Amigo que escupe fuego con alas poderosas'
    },
    color: '#EF4444',
    emoji: '🐉'
  },
  {
    type: 'unicorn',
    name: {
      en: 'Unicorn',
      es: 'Unicornio'
    },
    description: {
      en: 'Magical creature with a sparkly horn',
      es: 'Criatura mágica con un cuerno brillante'
    },
    color: '#A855F7',
    emoji: '🦄'
  },
  {
    type: 'mermaid',
    name: {
      en: 'Mermaid',
      es: 'Sirena'
    },
    description: {
      en: 'Ocean friend who swims with the fish',
      es: 'Amiga del océano que nada con los peces'
    },
    color: '#06B6D4',
    emoji: '🧜'
  },
  {
    type: 'turtle',
    name: {
      en: 'Turtly',
      es: 'Tortugui'
    },
    description: {
      en: 'Wise turtle with a strong protective shell',
      es: 'Tortuga sabia con un caparazón protector fuerte'
    },
    color: '#10B981',
    emoji: '🐢'
  },
  {
    type: 'spider',
    name: {
      en: 'SpiderX',
      es: 'Arañix'
    },
    description: {
      en: 'Creative spider who weaves magical webs',
      es: 'Araña creativa que teje redes mágicas'
    },
    color: '#8B5CF6',
    emoji: '🕷️'
  },
  {
    type: 'elephant',
    name: {
      en: 'Elephantis',
      es: 'Elefantis'
    },
    description: {
      en: 'Gentle giant with amazing memory',
      es: 'Gigante gentil con memoria increíble'
    },
    color: '#6B7280',
    emoji: '🐘'
  },
  {
    type: 'butterfly',
    name: {
      en: 'Butterfly',
      es: 'Mariposa'
    },
    description: {
      en: 'Beautiful flyer who spreads joy and color',
      es: 'Voladora hermosa que esparce alegría y color'
    },
    color: '#F59E0B',
    emoji: '🦋'
  },
  {
    type: 'owl',
    name: {
      en: 'Owl',
      es: 'Búho'
    },
    description: {
      en: 'Wise night creature with keen eyes',
      es: 'Criatura nocturna sabia con ojos agudos'
    },
    color: '#92400E',
    emoji: '🦉'
  },
  {
    type: 'fox',
    name: {
      en: 'Fox',
      es: 'Zorro'
    },
    description: {
      en: 'Clever forest friend with quick wit',
      es: 'Amigo del bosque astuto y rápido'
    },
    color: '#F97316',
    emoji: '🦊'
  }
];

// 8 Biotic Powers (living things)
export const BIOTIC_POWERS: SuperpowerCard[] = [
  {
    id: 'biotic-1',
    type: 'biotic',
    name: {
      en: 'Flower Power',
      es: 'Poder de Flores'
    },
    description: {
      en: 'Make flowers bloom wherever you go',
      es: 'Haz florecer flores donde vayas'
    },
    icon: '🌸',
    color: '#EC4899'
  },
  {
    id: 'biotic-2',
    type: 'biotic',
    name: {
      en: 'Tree Friend',
      es: 'Amigo de Árboles'
    },
    description: {
      en: 'Talk to trees and help them grow',
      es: 'Habla con los árboles y ayúdalos a crecer'
    },
    icon: '🌳',
    color: '#10B981'
  },
  {
    id: 'biotic-3',
    type: 'biotic',
    name: {
      en: 'Animal Whisperer',
      es: 'Susurrador de Animales'
    },
    description: {
      en: 'Understand what animals are saying',
      es: 'Entiende lo que dicen los animales'
    },
    icon: '🦋',
    color: '#F59E0B'
  },
  {
    id: 'biotic-4',
    type: 'biotic',
    name: {
      en: 'Garden Magic',
      es: 'Magia de Jardín'
    },
    description: {
      en: 'Grow amazing gardens instantly',
      es: 'Cultiva jardines increíbles al instante'
    },
    icon: '🌻',
    color: '#EAB308'
  },
  {
    id: 'biotic-5',
    type: 'biotic',
    name: {
      en: 'Bee Dance',
      es: 'Danza de Abejas'
    },
    description: {
      en: 'Dance with bees and make honey',
      es: 'Baila con las abejas y haz miel'
    },
    icon: '🐝',
    color: '#F59E0B'
  },
  {
    id: 'biotic-6',
    type: 'biotic',
    name: {
      en: 'Mushroom Magic',
      es: 'Magia de Hongos'
    },
    description: {
      en: 'Find magical mushrooms everywhere',
      es: 'Encuentra hongos mágicos por todas partes'
    },
    icon: '🍄',
    color: '#DC2626'
  },
  {
    id: 'biotic-7',
    type: 'biotic',
    name: {
      en: 'Seed Singer',
      es: 'Cantante de Semillas'
    },
    description: {
      en: 'Sing to seeds and watch them sprout',
      es: 'Canta a las semillas y míralas brotar'
    },
    icon: '🌱',
    color: '#84CC16'
  },
  {
    id: 'biotic-8',
    type: 'biotic',
    name: {
      en: 'Forest Friend',
      es: 'Amigo del Bosque'
    },
    description: {
      en: 'Help all forest creatures be happy',
      es: 'Ayuda a todas las criaturas del bosque a ser felices'
    },
    icon: '🦊',
    color: '#EA580C'
  }
];

// 8 Abiotic Powers (non-living things)
export const ABIOTIC_POWERS: SuperpowerCard[] = [
  {
    id: 'abiotic-1',
    type: 'abiotic',
    name: {
      en: 'Sun Beam',
      es: 'Rayo de Sol'
    },
    description: {
      en: 'Control sunlight and make rainbows',
      es: 'Controla la luz del sol y haz arcoíris'
    },
    icon: '☀️',
    color: '#FBBF24'
  },
  {
    id: 'abiotic-2',
    type: 'abiotic',
    name: {
      en: 'Rain Dancer',
      es: 'Bailarín de Lluvia'
    },
    description: {
      en: 'Make it rain when plants are thirsty',
      es: 'Haz llover cuando las plantas tengan sed'
    },
    icon: '🌧️',
    color: '#3B82F6'
  },
  {
    id: 'abiotic-3',
    type: 'abiotic',
    name: {
      en: 'Wind Rider',
      es: 'Jinete del Viento'
    },
    description: {
      en: 'Ride the wind and spread seeds',
      es: 'Cabalga el viento y esparce semillas'
    },
    icon: '💨',
    color: '#60A5FA'
  },
  {
    id: 'abiotic-4',
    type: 'abiotic',
    name: {
      en: 'Rock Climber',
      es: 'Escalador de Rocas'
    },
    description: {
      en: 'Climb any mountain or rock',
      es: 'Escala cualquier montaña o roca'
    },
    icon: '⛰️',
    color: '#78716C'
  },
  {
    id: 'abiotic-5',
    type: 'abiotic',
    name: {
      en: 'Water Weaver',
      es: 'Tejedor de Agua'
    },
    description: {
      en: 'Shape water into beautiful forms',
      es: 'Da forma al agua en formas hermosas'
    },
    icon: '💧',
    color: '#06B6D4'
  },
  {
    id: 'abiotic-6',
    type: 'abiotic',
    name: {
      en: 'Cloud Maker',
      es: 'Hacedor de Nubes'
    },
    description: {
      en: 'Create clouds in any shape',
      es: 'Crea nubes de cualquier forma'
    },
    icon: '☁️',
    color: '#94A3B8'
  },
  {
    id: 'abiotic-7',
    type: 'abiotic',
    name: {
      en: 'Snow Friend',
      es: 'Amigo de la Nieve'
    },
    description: {
      en: 'Make beautiful snowflakes',
      es: 'Haz hermosos copos de nieve'
    },
    icon: '❄️',
    color: '#0EA5E9'
  },
  {
    id: 'abiotic-8',
    type: 'abiotic',
    name: {
      en: 'Earth Shaper',
      es: 'Moldeador de Tierra'
    },
    description: {
      en: 'Shape soil to help plants grow',
      es: 'Moldea la tierra para ayudar a crecer a las plantas'
    },
    icon: '🌍',
    color: '#65A30D'
  }
];

// All powers combined
export const ALL_POWERS = [...BIOTIC_POWERS, ...ABIOTIC_POWERS];

// Sticker collections for drawing - 69 total stickers!
export const STICKERS = {
  eyes: [
    { id: 'eyes-1', type: 'eyes' as const, svg: eyesRound, name: { en: 'Round Eyes', es: 'Ojos Redondos' } },
    { id: 'eyes-2', type: 'eyes' as const, svg: eyesWink, name: { en: 'Wink', es: 'Guiño' } },
    { id: 'eyes-3', type: 'eyes' as const, svg: eyesHappy, name: { en: 'Happy Eyes', es: 'Ojos Felices' } },
    { id: 'eyes-4', type: 'eyes' as const, svg: eyesHeart, name: { en: 'Heart Eyes', es: 'Ojos de Corazón' } },
    { id: 'eyes-5', type: 'eyes' as const, svg: eyesStar, name: { en: 'Star Eyes', es: 'Ojos de Estrella' } },
    { id: 'eyes-6', type: 'eyes' as const, svg: eyesGemstone, name: { en: 'Gem Eyes', es: 'Ojos de Gema' } },
  ],
  mouths: [
    { id: 'mouth-1', type: 'mouth' as const, svg: mouthSmile, name: { en: 'Big Smile', es: 'Gran Sonrisa' } },
    { id: 'mouth-2', type: 'mouth' as const, svg: mouthTongue, name: { en: 'Silly Tongue', es: 'Lengua Traviesa' } },
    { id: 'mouth-3', type: 'mouth' as const, svg: mouthGentle, name: { en: 'Gentle Smile', es: 'Sonrisa Suave' } },
    { id: 'mouth-4', type: 'mouth' as const, svg: mouthSurprised, name: { en: 'Surprised', es: 'Sorprendido' } },
  ],
  accessories: [
    { id: 'acc-1', type: 'accessories' as const, svg: crown, name: { en: 'Crown', es: 'Corona' } },
    { id: 'acc-2', type: 'accessories' as const, svg: crownFlower, name: { en: 'Flower Crown', es: 'Corona de Flores' } },
    { id: 'acc-3', type: 'accessories' as const, svg: bow, name: { en: 'Bow', es: 'Lazo' } },
    { id: 'acc-4', type: 'accessories' as const, svg: star, name: { en: 'Star', es: 'Estrella' } },
    { id: 'acc-5', type: 'accessories' as const, svg: sparkles, name: { en: 'Sparkles', es: 'Brillos' } },
    { id: 'acc-6', type: 'accessories' as const, svg: hornCrystal, name: { en: 'Crystal Horn', es: 'Cuerno de Cristal' } },
    { id: 'acc-7', type: 'accessories' as const, svg: beardMoss, name: { en: 'Moss Beard', es: 'Barba de Musgo' } },
    { id: 'acc-8', type: 'accessories' as const, svg: earsLeaf, name: { en: 'Leaf Ears', es: 'Orejas de Hoja' } },
    { id: 'acc-9', type: 'accessories' as const, svg: earsCoral, name: { en: 'Coral Ears', es: 'Orejas de Coral' } },
    { id: 'acc-10', type: 'accessories' as const, svg: earsSeashell, name: { en: 'Seashell Ears', es: 'Orejas de Concha' } },
    { id: 'acc-11', type: 'accessories' as const, svg: earsFlowerPetal, name: { en: 'Petal Ears', es: 'Orejas de Pétalo' } },
    { id: 'acc-12', type: 'accessories' as const, svg: earsFeather, name: { en: 'Feather Ears', es: 'Orejas de Pluma' } },
    { id: 'acc-13', type: 'accessories' as const, svg: hairFire, name: { en: 'Fire Hair', es: 'Cabello de Fuego' } },
    { id: 'acc-14', type: 'accessories' as const, svg: hairWater, name: { en: 'Water Hair', es: 'Cabello de Agua' } },
    { id: 'acc-15', type: 'accessories' as const, svg: hairCloud, name: { en: 'Cloud Hair', es: 'Cabello de Nube' } },
    { id: 'acc-16', type: 'accessories' as const, svg: hairVineTendrils, name: { en: 'Vine Hair', es: 'Cabello de Enredadera' } },
    { id: 'acc-17', type: 'accessories' as const, svg: hairRainbowMohawk, name: { en: 'Rainbow Mohawk', es: 'Mohawk Arcoíris' } },
    { id: 'acc-18', type: 'accessories' as const, svg: hairMushroomCap, name: { en: 'Mushroom Cap', es: 'Gorro de Hongo' } },
    { id: 'acc-19', type: 'accessories' as const, svg: hairLightningSpikes, name: { en: 'Lightning Spikes', es: 'Picos de Rayo' } },
    { id: 'acc-20', type: 'accessories' as const, svg: hairLeafPile, name: { en: 'Leaf Pile', es: 'Montón de Hojas' } },
    { id: 'acc-21', type: 'accessories' as const, svg: hairIcicleSpikes, name: { en: 'Icicle Spikes', es: 'Picos de Hielo' } },
    { id: 'acc-22', type: 'accessories' as const, svg: wingsButterfly, name: { en: 'Butterfly Wings', es: 'Alas de Mariposa' } },
    { id: 'acc-23', type: 'accessories' as const, svg: wingsLightning, name: { en: 'Lightning Wings', es: 'Alas de Rayo' } },
    { id: 'acc-24', type: 'accessories' as const, svg: tailFirefly, name: { en: 'Firefly Tail', es: 'Cola de Luciérnaga' } },
    { id: 'acc-25', type: 'accessories' as const, svg: tailRainbow, name: { en: 'Rainbow Tail', es: 'Cola Arcoíris' } },
    { id: 'acc-26', type: 'accessories' as const, svg: tailFish, name: { en: 'Fish Tail', es: 'Cola de Pez' } },
    { id: 'acc-27', type: 'accessories' as const, svg: handsStarfish, name: { en: 'Starfish Hands', es: 'Manos de Estrella de Mar' } },
    { id: 'acc-28', type: 'accessories' as const, svg: bodyGemstoneBelly, name: { en: 'Gem Belly', es: 'Barriga de Gema' } },
    { id: 'acc-29', type: 'accessories' as const, svg: faceRainbowStripe, name: { en: 'Rainbow Stripe', es: 'Raya Arcoíris' } },
    { id: 'acc-30', type: 'accessories' as const, svg: faceStarFreckles, name: { en: 'Star Freckles', es: 'Pecas de Estrella' } },
    { id: 'acc-31', type: 'accessories' as const, svg: markingMoonPhase, name: { en: 'Moon Phases', es: 'Fases de Luna' } },
    { id: 'acc-32', type: 'accessories' as const, svg: toolWand, name: { en: 'Magic Wand', es: 'Varita Mágica' } },
    { id: 'acc-33', type: 'accessories' as const, svg: toolStaff, name: { en: 'Staff', es: 'Bastón' } },
    { id: 'acc-34', type: 'accessories' as const, svg: toolSnowflake, name: { en: 'Snowflake Tool', es: 'Herramienta Copo de Nieve' } },
    { id: 'acc-35', type: 'accessories' as const, svg: toolLightning, name: { en: 'Lightning Bolt', es: 'Rayo' } },
    { id: 'acc-36', type: 'accessories' as const, svg: toolShellHorn, name: { en: 'Shell Horn', es: 'Cuerno de Concha' } },
    { id: 'acc-37', type: 'accessories' as const, svg: toolLantern, name: { en: 'Lantern', es: 'Linterna' } },
    { id: 'acc-38', type: 'accessories' as const, svg: toolBouquet, name: { en: 'Flower Bouquet', es: 'Ramo de Flores' } },
    { id: 'acc-39', type: 'accessories' as const, svg: toolAcornPouch, name: { en: 'Acorn Pouch', es: 'Bolsa de Bellotas' } },
  ],
  decorations: [
    { id: 'dec-1', type: 'decorations' as const, svg: flower, name: { en: 'Flower', es: 'Flor' } },
    { id: 'dec-2', type: 'decorations' as const, svg: star, name: { en: 'Star', es: 'Estrella' } },
    { id: 'dec-3', type: 'decorations' as const, svg: heart, name: { en: 'Heart', es: 'Corazón' } },
    { id: 'dec-4', type: 'decorations' as const, svg: butterfly, name: { en: 'Butterfly', es: 'Mariposa' } },
    { id: 'dec-5', type: 'decorations' as const, svg: effectSparkles, name: { en: 'Sparkle Effect', es: 'Efecto de Brillos' } },
    { id: 'dec-6', type: 'decorations' as const, svg: effectWater, name: { en: 'Water Effect', es: 'Efecto de Agua' } },
    { id: 'dec-7', type: 'decorations' as const, svg: effectFrost, name: { en: 'Frost Effect', es: 'Efecto de Escarcha' } },
    { id: 'dec-8', type: 'decorations' as const, svg: effectMagic, name: { en: 'Magic Effect', es: 'Efecto Mágico' } },
    { id: 'dec-9', type: 'decorations' as const, svg: effectGhostly, name: { en: 'Ghostly Effect', es: 'Efecto Fantasmal' } },
    { id: 'dec-10', type: 'decorations' as const, svg: effectGlowStars, name: { en: 'Glow Stars', es: 'Estrellas Brillantes' } },
    { id: 'dec-11', type: 'decorations' as const, svg: effectMagnetic, name: { en: 'Magnetic Effect', es: 'Efecto Magnético' } },
    { id: 'dec-12', type: 'decorations' as const, svg: effectColorChangeGems, name: { en: 'Color Gems', es: 'Gemas de Color' } },
  ]
};

// Pre-made creature names for "pick a name" option
export const CREATURE_NAMES = {
  en: [
    'Sparkle', 'Shimmer', 'Glimmer', 'Twinkle',
    'Rainbow', 'Sunny', 'Blossom', 'Petal',
    'Sprout', 'Leaf', 'Sky', 'Cloud',
    'River', 'Ocean', 'Star', 'Moon'
  ],
  es: [
    'Brillo', 'Destello', 'Chispa', 'Centelleo',
    'Arcoíris', 'Solecito', 'Flor', 'Pétalo',
    'Brote', 'Hoja', 'Cielo', 'Nube',
    'Río', 'Océano', 'Estrella', 'Luna'
  ]
};

// Sound syllables for "mix sounds" naming
export const SOUND_SYLLABLES = {
  en: ['ba', 'la', 'ma', 'ra', 'za', 'ki', 'lo', 'po', 'ti', 'wa'],
  es: ['ba', 'la', 'ma', 'ra', 'sa', 'ki', 'lo', 'po', 'ti', 'ña']
};
